<template>
  <section class="panel-body">
    <br>
    <div class="form-group">
      <router-link to="/empresas" class="btn-default btn">
        <i class="fa fa-times"></i>
        {{$t('words.cancel') }}
      </router-link>
      <button type="button" @click="saveData()" class="btn btn-success float-right">
        <i class="fa fa-check"></i>
        {{ $t('words.save')}}
      </button>
    </div>
    <div class="card card-outline card-outline-tabs" :class="appLayout.card">
      <div class="card-header p-0 border-bottom-0">
        <div class="nav-tabs-custom" role="tabpanel">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="nav-item">
              <a href="#tabEmpresa" class="nav-link active" aria-controls="tabEmpresa" role="tab" data-toggle="tab">
                <i class="fa fa-building"></i>
                {{ $t('words.data_company')}}
              </a>
            </li>
            <li role="presentation" class="nav-item" v-if="$route.name === 'empresaCreate'">
              <a href="#tabUsuario" class="nav-link" aria-controls="tabUsuario" role="tab" data-toggle="tab">
                <i class="fa fa-user"></i>
                {{ $tc('attributes.user', 1)}}
              </a>
            </li>
            <li role="presentation" class="nav-item">
              <a href="#tabIntegracao" class="nav-link" aria-controls="tabIntegracao" role="tab" data-toggle="tab">
                <i class="fa fa-globe"></i>
                Integração
              </a>
            </li>
            <li role="presentation" class="nav-item" v-if="auth_user.ambiente == 'A'">
              <a href="#tabManutencao" class="nav-link" aria-controls="tabManutencao" role="tab" data-toggle="tab">
                <i class="fa fa-wrench"></i>
                Manutenção
              </a>
            </li>
            <li role="presentation" class="nav-item" v-if="auth_user.ambiente == 'A' && empresa.is_revenda">
              <a href="#tabRevenda" class="nav-link" aria-controls="tabRevenda" role="tab" data-toggle="tab">
                <i class="ion ion-bag"></i>
                Parceiros Revenda
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body">
          <!-- Tab panes -->
          <div class="tab-content">
            <!-- INICIO TAB EMPRESA -->
            <div class="tab-pane active" id="tabEmpresa">
              <div class="form-group"> <span v-html="$t('validation.field_required')"></span></div>
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="form-group">
                    <required /> <label>CPF / CNPJ</label>
                    <i v-if="isLoadingCnpj" class="fa fa-refresh fa-spin"></i>
                    <label class="control-label validator float-right"
                      :class="{hide:!errors.has('cnpj_label') && !errors.has('cnpj_success')}" for="inputError">
                      <i
                        :class="{'fa fa-times-circle-o': errors.has('cnpj'),'fa fa-check':errors.has('cnpj_success'), 'fa fa-warning':errors.has('cnpj_404') }"></i>
                      {{errors.first('cnpj_label')}}
                    </label>
                    <div class="input-group">
                      <input
                        :class="{ 'is-invalid': errors.has('cnpj'),'has-success':errors.has('cnpj_success'),'has-warning':errors.has('cnpj_404') }"
                        v-on:keyup.enter="searchCnpj()" v-model="empresa.empresa_documento" class="form-control"
                        name="cnpj" v-validate="'required|max:18'" :placeholder="$t('words.type_cnpj')"
                        v-mask="['###.###.###-##','##.###.###/####-##']" type="text" />
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-default" @click="searchCnpj"
                          :title="$t('words.btn_search_cnpj')">
                          <span class="fa fa-search"></span>
                        </button>
                      </span>
                    </div>
                    <div class="invalid-feedback help-block error">{{errors.first('cnpj')}}
                      {{ errors.first('cnpj_success')}}
                      {{errors.first('cnpj_404')}}</div>
                  </div>
                </div>
                <template v-if="auth_user.ambiente == 'A'">
                  <div class="offset-1 form-group">
                    <label>Revenda? </label>
                    <p-check class="p-switch p-fill" :color="appLayout.check" v-model="empresa.is_revenda" />
                  </div>
                  <div v-if="!empresa.is_revenda" class="col form-group"
                    :class="{'is-invalid': errors.has('emp_revenda') }">
                    <required />
                    <label>Id Revenda</label>
                    <select v-if="revenda" name="emp_revenda" v-model="empresa.id_revenda" :class="'form-control'"
                      v-validate="{required: !empresa.is_revenda}" :placeholder="'Preencha o ID da empresa Revenda'">
                      <option :value="null">Selecione...</option>
                      <option v-for="emp in revenda" :key="'revenda-'+emp.id" :value="emp.id"> {{ emp.empresa_nome }} -
                        {{ formatDocument(emp.empresa_documento) }}
                      </option>
                    </select>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group" :class="{'is-invalid': errors.has('social_name')}">
                    <required /> <label>{{ $t('attributes.social_name')}}</label>
                    <input name="social_name" v-model="empresa.empresa_nome" v-validate="{required: true, max:120}"
                      type="text" class="form-control" :placeholder="$t('words.type_social_name')">
                    <div class="invalid-feedback help-block error">{{errors.first('social_name')}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('phone') }">
                    <required /> <label>{{ $t('attributes.phone')}}</label>
                    <input name="phone" v-model="empresa.empresa_telefone" v-validate="'required|max:20'"
                      class="form-control" :placeholder="$t('words.type_phone')"
                      v-mask="['(##)####-####', '(##)#####-####']" type="text" />
                    <div class="invalid-feedback help-block error">{{errors.first('phone')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('note') }">
                    <label>{{ $t('attributes.note')}}</label>
                    <textarea name="note" v-model="empresa.empresa_observacao" v-validate="{max:255}"
                      class="form-control" :placeholder="$t('words.type_note')"></textarea>
                    <div class="invalid-feedback help-block error">{{errors.first('note')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group"
                    :class="{ 'is-invalid': errors.has('zip'), 'has-warning':errors.has('zip_404') }">
                    <required />
                    <label>{{ $t('attributes.zip')}}</label>
                    <label class="control-label validator float-right" :class="{hide:!errors.has('zip_label')}"
                      for="inputError">
                      <i
                        :class="{'fa fa-times-circle-o': errors.has('zip'), 'fa fa-warning':errors.has('zip_404') }"></i>
                      {{errors.first('zip_label')}}
                    </label>
                    <div class="input-group">
                      <input class="form-control" @keypress.enter="searchZip" v-model="empresa.empresa_cep" name="zip"
                        v-validate="'required|max:9'" :placeholder="$t('words.type_zip')" v-mask="'#####-###'"
                        type="text" />
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-default" @click="searchZip"
                          :title="$t('words.btn_search_zip')">
                          <span class="fa fa-search"></span>
                        </button>
                      </span>
                    </div>
                    <div class="invalid-feedback help-block error">{{errors.first('zip')}} {{errors.first('zip_404')}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('address') }">
                    <required />
                    <label>{{ $t('attributes.address')}}</label>
                    <input name="address" v-model="empresa.empresa_endereco" v-validate="{required:true,max:60}"
                      type="text" class="form-control" :placeholder="$t('words.type_address')">
                    <div class="invalid-feedback help-block error">{{errors.first('address')}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('number') }">
                    <required />
                    <label>{{ $t('attributes.number') }}</label>
                    <input name="number" v-model="empresa.empresa_numero" v-validate="{required:true,max:60}"
                      type="text" class="form-control" :placeholder="$t('words.type_number')">
                    <div class="invalid-feedback help-block error">{{errors.first('number')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('neighborhood') }">
                    <required />
                    <label>{{ $t('attributes.neighborhood')}}</label>
                    <input name="neighborhood" v-model="empresa.empresa_bairro" v-validate="{required:true,max:60}"
                      type="text" class="form-control" :placeholder="$t('words.type_neighborhood')">
                    <div class="invalid-feedback help-block error">{{errors.first('neighborhood')}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('state') }">
                    <required />
                    <label>{{ $t('attributes.state')}}</label>
                    <select name="state" @change="getCidades(empresa.empresa_estado, empresa, 'empresa.empresa_ibge')"
                      v-model="empresa.empresa_estado" v-validate="{required:true}"
                      :data-error="$t('validation.require_select')" class="form-control">
                      <option :value="null">{{ $t('words.select')}}</option>
                      <option v-for="(item, i) in estados" :value="item.id" :key="i">{{item.name}}</option>
                    </select>
                    <div class="invalid-feedback help-block error">{{errors.first('state')}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('city') }">
                    <required />
                    <label>{{$tc('attributes.city', 1)}}</label>
                    <select v-model="empresa.empresa_ibge" @change="getCidadeName()"
                      :disabled="empresa.empresa_estado === null" name="city" v-validate="{required:true}"
                      class="form-control">
                      <option :value="null">{{ $t('words.select')}}</option>
                      <option v-for="(item, i) in cidades" :value="item.id" :key="i">{{item.name}}</option>
                    </select>
                    <div class="invalid-feedback help-block error">{{errors.first('city')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group" :class="{ 'is-invalid': errors.has('complement') }">
                    <span class="invisible">
                      <required />
                    </span>
                    <label>{{ $t('attributes.complement')}}</label>
                    <input name="complement" v-model="empresa.empresa_complemento" v-validate="{required:false,max:60}"
                      type="text" class="form-control" :placeholder="$t('words.type_complement')">
                    <div class="invalid-feedback help-block error">{{errors.first('complement')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="$route.name === 'empresaCreate'" class="tab-pane" id="tabUsuario">
              <form-user ref="FormUser" :usuario="usuario"></form-user>
            </div>
            <div class="tab-pane" id="tabIntegracao">
              <div class="row">
                <div class="col-md-9">
                  <div class="form-group">
                    <label><i class="fa fa-shield"></i> Token para Integração</label><button @click="generateToken()"
                      class="float-right btn-sm btn btn-default"><i class="fa fa-recycle"></i> Gerar
                      token</button>
                    <textarea disabled v-model="empresa.token" class="form-control" rows="6"
                      placeholder="Token de Acesso"></textarea>
                    <a @click="copy(empresa.token)" class="float-right" href="#"><i class="fa fa-files-o"></i>
                      Copiar</a>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <required /><label>Nível para salvar os arquivos</label>
                    <select v-model="empresa.nivel_api" class="form-control">
                      <option :value="null">{{$t('words.select')}}</option>
                      <option v-for="(item, i) in empresa.folders" :key="i" :value="item.id">{{item.title}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <a :href="url" target="_blank"> Link para documentação da API</a>
                </div>
              </div>
            </div>
            <div class="tab-pane" v-if="auth_user.ambiente == 'A'" id="tabManutencao">
              <div class="row">
                <div class="col-md-12">
                  <label>
                    <required></required> Atenção, processo pode demorar um tempo!!
                  </label>
                  <button :disabled="loading" @click="fixStructure()" class=" float-right btn btn-danger"><i
                      class="fa fa-bug"></i> Recriar Estrutura de Pastas</button>
                  <div class="form-group">
                    <label>Arquivo SQL</label>
                    <div class="input-group">
                      <input type="file" v-on:change="handleFileUpload()" ref="file" name="file" accept=".xlsx"
                        class="form-control">
                      <span class="input-group-btn">
                        <button :disabled="loading" @click="migrate()" class="btn btn-default"><i
                            class="fa fa-folder"></i>
                          Importar Estrutura</button>
                        <button :disabled="loading" @click="fixMigrate()" class="btn btn-success"><i
                            class="fa fa-upload"></i> Upload Arquivos</button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" v-if="auth_user.ambiente == 'A'" id="tabRevenda">
              <div class="row align-items-center">
                <div class="col-md-6 form-group m-0">
                  <label>Logo: </label>
                  <div v-if="empresa.image || empresa.logo_64" class="text-right mx-auto">
                    <i @click="empresa.image=null;empresa.logo_64=null;empresa.logo=null;$forceUpdate()"
                      class="btn fa fa-times text-danger p-0"></i>
                  </div>
                  <div @click="changePhoto" class="image-container mx-auto border text-center"
                    :class="{ 'uploading': loading }">
                    <img id="logo" :src="empresa.image || empresa.logo_64 || require('@/assets/you-logo.png')" />
                    <my-upload :field="'upload'" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess"
                      @crop-upload-fail="cropUploadFail" v-model="show" :noRotate="false" langType="pt-br" :width="300"
                      :height="75" img-format="png">
                    </my-upload>
                  </div>
                  <div class="text-center">
                    <required /> <small> Tamanho sugerido: 300x75px</small>
                  </div>
                </div>
                <div class="col-md-6 form-group" :class="{'is-invalid': errors.has('dominio_revenda') }">
                  <label>Dominio: </label>
                  <input v-model="empresa.link_domain" name="dominio_revenda" type="text" class="form-control"
                    v-validate="{required: (empresa.is_revenda)}"
                    placeholder="Preencha o Sub-Dominio (Ex: sub-dominio.docxdigital.com.br)">
                </div>
                <div class="col-md-6 form-group">
                  <label>Site: </label>
                  <input v-model="empresa.link_site" name="site_revenda" type="text" class="form-control"
                    placeholder="Preencha o link do Site">
                </div>
                <div class="col-md-6 form-group">
                  <label>Facebook: </label>
                  <input v-model="empresa.link_facebook" name="facebook_revenda" type="text" class="form-control"
                    placeholder="Preencha o link do Facebook">
                </div>
                <div class="col-md-6 form-group">
                  <label>Instagram: </label>
                  <input v-model="empresa.link_instagram" name="instagram_revenda" type="text" class="form-control"
                    placeholder="Preencha o link do Instagram">
                </div>
                <div class="col-md-6 form-group">
                  <label>LinkedIn: </label>
                  <input v-model="empresa.link_linkedin" name="linkedin_revenda" type="text" class="form-control"
                    placeholder="Preencha o link do LinkedIn">
                </div>
                <div class="col-md-6 form-group">
                  <label>Youtube: </label>
                  <input v-model="empresa.link_youtube" name="youtube_revenda" type="text" class="form-control"
                    placeholder="Preencha o link do Youtube">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import FormUser from '../users/components/form-default';
  import myUpload from 'vue-image-crop-upload';
  export default {
    components: {
      FormUser,
      myUpload
    },
    data() {
      return {
        isLoadingCnpj: false,
        loading: false,
        empresa: {
          fk_plano_id: null,
          empresa_ambiente: 1,
          is_revenda: false,
          id_revenda: null
        },
        usuario: {
          fk_cargo_id: null
        },
        form: {
          file: null,
        },
        cidades: [],
        show: false,
        revenda: []
      };
    },
    computed: {
      url() {
        return `${process.env.VUE_APP_BASE_URL}/api/documentation`;
      }
    },
    beforeMount() {
      if (this.$route.name === 'empresaEdit') this.getById();
      this.$store.state.empresa.revenda.map(r => {
        if (r.id != this.$route.params.id) this.revenda.push(r)
      });
    },
    watch: {
      $route(data) {
        if (this.$route.name === 'empresaEdit') {
          this.getById();
        } else {
          Object.assign(this.$data, this.$options.data());
          this.$validator.reset();
        }
        this.$destroy();
      },
      'empresa.empresa_documento'(data) {
        if (data && data.length == 18) {
          if (this.$route.name === 'empresaCreate') {
            this.checkUniqueCnpj();
          } else {
            let cnpj = this.isValidCnpj(this.empresa.empresa_documento);
            cnpj ? this.validCnpj() : this.invalidCnpj();
          }
        } else {
          this.errors.remove('cnpj_success');
          this.errors.remove('cnpj_label');
        }
      },
    },
    methods: {
      resetCity() {
        if (this.cidades.findIndex(item => item.id == this.empresa.empresa_ibge) == -1) {
          this.empresa.empresa_ibge = null;
        }
        this.getEstadoUf();
      },
      getEstadoUf() {
        if (!this.empresa.empresa_estado) {
          return;
        }
        this.empresa.empresa_uf = this.estados.find(x => x.id == this.empresa.empresa_estado).uf;
      },
      getCidadeName() {
        this.empresa.empresa_cidade = this.cidades.find(x => x.id == this.empresa.empresa_ibge).name;
      },
      handleFileUpload() {
        this.form.file = this.$refs.file.files[0];
      },
      migrate() {
        let formData = new FormData();
        formData.append('file', this.form.file);
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.loading = true;
            let req = {
              form: formData,
              config: config,
              id: this.$route.params.id
            };
            this.$store.dispatch('migratePrime', req)
              .then(response => {
                this.loading = false;
              });
          }
        });
      },
      fixMigrate() {
        let formData = new FormData();
        formData.append('file', this.form.file);
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.loading = true;
            let req = {
              form: formData,
              config: config,
              id: this.$route.params.id
            };
            this.$store.dispatch('fixMigratePrime', req)
              .then(response => {
                this.loading = false;
              });
          }
        });
      },
      fixStructure() {
        this.loading = true;
        this.$store
          .dispatch('fixStructure', this.$route.params.id)
          .then(response => {
            this.loading = false;
          });
      },
      getById() {
        this.$store.dispatch('getEmpresaById', this.$route.params.id)
          .then(response => {
            this.empresa = response;
            if (response.is_revenda == 0) this.empresa.is_revenda = false
            this.getCidades(this.empresa.empresa_estado);
          })
      },
      checkUserEmail() {
        if (!this.errors.has('user_email') && this.usuario.username !== '') {
          this.isLoadingEmail = true;
          this.$store
            .dispatch('checkUniqueEmail', this.usuario.username)
            .then(response => {
              this.isLoadingEmail = false;
              response ? this.validEmailUser() : this.invalidEmailUser();
            });
        } else {
          this.removeUserEmailAlert();
        }
      },
      async saveData() {
        if (this.$route.name == 'empresaCreate') {
          let userValid = await this.$refs.FormUser.validateAll();
          if (!userValid) {
            $(`[href="#tabUsuario"]`).tab('show');
            return;
          }
        }
        this.$validator.validateAll().then(valid => {
          if (valid) {
            if (this.empresa.is_revenda) this.empresa.id_revenda = null
            else {
              this.empresa.link_domain = null
              this.empresa.link_site = null
              this.empresa.link_facebook = null
              this.empresa.link_instagram = null
              this.empresa.link_linkedin = null
              this.empresa.link_youtube = null
              this.empresa.logo = null
              this.empresa.logo_64 = null
            };
            if (this.$route.name === 'empresaCreate') {
              this.storeEmpresa();
            } else {
              this.updateEmpresa();
            }
          } else {
            const field = this.$validator.fields.find({
              name: 'dominio_revenda'
            }).flags.valid
            if (!field) $(`[href="#tabRevenda"]`).tab('show');
            else $(`[href="#tabEmpresa"]`).tab('show');
            toastr({
              icon: 'error',
              title: 'Verifique os itens em vermelho.'
            });
          }
        });
      },
      storeEmpresa() {
        if (!this.usuario.form) {
          Swal.fire({
            title: trans('words.confirm'),
            html: trans('message.confirm_store_company'),
            icon: 'question',
            allowOutsideClick: true,
            showCancelButton: true,
            cancelButtonText: trans('words.close'),
            confirmButtonText: trans('words.confirm'),
            confirmButtonClass: 'btn btn-success float-right',
            cancelButtonClass: 'btn btn-default btn-lg float-left',
            buttonsStyling: false,
            reverseButtons: true,
            showLoaderOnConfirm: true,
            preConfirm: confirm => {
              if (confirm) {
                this.empresa.gestor = this.usuario;
                return this.$store.dispatch('storeEmpresa', this.empresa)
                  .then(response => {
                    return response;
                  });
              }
            }
          }).then(response => {
            if (response.value.status === 'success') {
              this.successSwal(response.value);
              Object.assign(this.$data, this.$options.data());
              this.errors.clear();
              this.$router.push('/empresas');
            } else {
              this.errorSwal(response.value.response.data);
            }
          });
        } else {
          this.usuario.form = false;
          this.saveData();
        }
      },
      updateEmpresa() {
        Swal.fire({
          title: 'Atualizar Empresa',
          html: trans('message.confirm_edit_company'),
          icon: 'question',
          showCancelButton: true,
          allowOutsideClick: true,
          cancelButtonText: trans('words.close'),
          confirmButtonText: 'Confirmar',
          confirmButtonClass: 'btn btn-success float-right',
          cancelButtonClass: 'btn btn-default btn-lg float-left',
          buttonsStyling: false,
          reverseButtons: true,
          showLoaderOnConfirm: true,
          preConfirm: (confirm) => {
            return this.$store.dispatch('updateEmpresa', this.empresa);
          }
        }).then(response => {
          if (response.value && response.value.status == 'success') {
            this.successSwal(response.value);
            this.$router.push('/empresas');
          } else if (response.value) this.errorSwal(response.value);
        });
      },
      checkUniqueCnpj() {
        if (this.isValidCnpj(this.empresa.empresa_documento)) {
          this.isLoadingCnpj = true;
          let cnpj = this.empresa.empresa_documento.replace(/\\./g, '').replace('-', '').replace('/', '');
          this.$store
            .dispatch('checkCompanyCnpj', cnpj)
            .then(response => {
              this.isLoadingCnpj = false;
              response ? this.validCnpj() : this.cnpjAlreadyTaken();
            });
        } else {
          this.invalidCnpj();
        }
      },
      invalidCnpj() {
        this.resetCnpjAlerts();
        this.errors.add({
          field: 'cnpj',
          msg: trans('message.cnpj_invalid_text')
        });
        this.errors.add({
          field: 'cnpj_label',
          msg: trans('message.cnpj_invalid')
        });
      },
      validCnpj() {
        this.resetCnpjAlerts();
        this.errors.add({
          field: 'cnpj_label',
          msg: trans('message.cnpj_valid')
        });
        this.errors.add({
          field: 'cnpj_success',
          msg: trans('message.cnpj_valid_text')
        });
      },
      cnpjAlreadyTaken() {
        this.resetCnpjAlerts();
        this.errors.add({
          field: 'cnpj',
          msg: trans('message.cnpj_used_text')
        });
        this.errors.add({
          field: 'cnpj_label',
          msg: trans('message.cnpj_used')
        });
      },
      cnpjNotFound() {
        this.resetCnpjAlerts();
        this.errors.add({
          field: 'cnpj_404',
          msg: trans('message.cnpj_404_text')
        });
        this.errors.add({
          field: 'cnpj_label',
          msg: trans('message.cnpj_404')
        });
      },
      resetCnpjAlerts() {
        this.errors.remove('cnpj');
        this.errors.remove('cnpj_success');
        this.errors.remove('cnpj_label');
        this.errors.remove('cnpj_404');
      },
      searchCnpj() {
        if (this.isValidCnpj(this.empresa.empresa_documento)) {
          this.isLoadingCnpj = true;
          service
            .searchCnpj(this.empresa.empresa_documento)
            .then(response => {
              let fields = response.telefone.split('/');
              let telefone0 = fields[0];
              let telefone1 = fields[1];
              this.empresa.empresa_telefone = telefone0;
              this.empresa.empresa_celular = telefone1;
              this.empresa.empresa_nome = response.fantasia;
              this.empresa.empresa_email = response.email;
              this.empresa.empresa_nome = response.nome;
              this.empresa.empresa_cnae_principal =
                response.atividade_principal[0].code;
              this.empresa.cnae_text = response.atividade_principal[0].text;
              this.empresa.empresa_cep = response.cep
                .replace('.', '')
                .replace('-', '');
              this.empresa.empresa_numero = response.numero;
              this.empresa.empresa_complemento = response.complemento;
              try {
                this.usuario.nome =
                  response.qsa.length > 0 ? response.qsa[0].nome : '';
              } catch (e) {
                console.log(e);
              }
              this.searchZip();
              // this.empresa.empresa_bairro = response.bairro;
              // this.empresa.empresa_endereco = response.logradouro;
              this.isLoadingCnpj = false;
            })
            .catch(error => {
              this.isLoadingCnpj = false;
              this.cnpjNotFound();
            });
        }
      },
      validUserDocument() {
        this.removeUserDocumentAlert();
        this.errors.add({
          field: 'user_document_ok',
          msg: 'Não encontramos problema com o documento informado.'
        });
      },
      invalidUserDocument() {
        this.removeUserDocumentAlert();
        this.errors.add({
          field: 'user_document',
          msg: 'O documento informado é inválido. Por favor, verifique.'
        });
      },
      removeUserDocumentAlert() {
        this.errors.remove('user_document');
        this.errors.remove('user_document_ok');
      },
      validEmailUser() {
        this.removeUserEmailAlert();
        this.errors.add({
          field: 'user_email_ok',
          msg: trans('message.email_valid_text')
        });
        this.errors.add({
          field: 'user_email_label',
          msg: trans('message.email_valid')
        });
      },
      invalidEmailUser() {
        this.removeUserEmailAlert();
        this.errors.add({
          field: 'user_email_bad',
          msg: trans('message.email_invalid_text')
        });
        this.errors.add({
          field: 'user_email_label',
          msg: trans('message.email_invalid')
        });
      },
      removeUserEmailAlert() {
        this.errors.remove('user_email_bad');
        this.errors.remove('user_email_ok');
        this.errors.remove('user_email_label');
      },
      searchZip() {
        if (this.empresa.empresa_cep != undefined) {
          service
            .searchZip(this.empresa.empresa_cep)
            .then(response => {
              if (response.uf !== undefined) {
                this.empresa.empresa_endereco = response.logradouro
                this.empresa.empresa_bairro = response.bairro
                this.empresa.empresa_estado = response.ibge.substring(0, 2);
                this.empresa.empresa_ibge = response.ibge
                this.empresa.nomeCidade = response.localidade;
                this.empresa.empresa_uf = response.uf;
                this.getCidades(this.empresa.empresa_estado);
                $('#Nro').focus();
                this.validate();
                this.getEstadoUf();
                this.getCidadeName();
              }
            })
            .catch(error => {
              this.isLoadingCep = false;
              this.dados.selected.endereco = ''
              this.dados.selected.bairro = ''
              this.dados.selected.estado = null
              this.dados.selected.cidade = null
            });
        }
      },
      generateToken() {
        this.loading = true;
        this.$store.dispatch('generateCompanyToken', this.$route.params.id).then(response => {
          this.empresa.token = response.access_token;
          toastr({
            title: 'Token Gerado',
            icon: 'success'
          });
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.loading = false;
        });
      },
      cropSuccess(imgDataUrl, field) {
        this.empresa.image = imgDataUrl;
      },
      cropUploadSuccess(jsonData, field) {},
      cropUploadFail(status, field) {
        toastr({
          icon: 'error',
          title: 'Erro ao atualizar a logo.'
        });
        this.empresa.logo_64 = require('@/assets/you-logo.png');
        this.show = false;
      },
      changePhoto() {
        this.show = true;
      },
    }
  };
</script>

<style scoped>
  .text-right {
    width: 302px;
  }

  .image-container {
    width: 302px;
    height: 77px;
  }

  .border {
    cursor: pointer
  }
</style>